<template>
    <div class="overview">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)"></myBreadCrumb> -->
        <v-row>
            <v-col cols="12" md="6" lg="4" xl="3">
                <dashboard-item to="HrTimeSheet" color="blue" icon="mdi-clock" :title="$t('manager_page.overview.timesheet')" :subtitle="$t('manager_page.overview.timesheet_subtitle')"></dashboard-item>
            </v-col>
            <v-col cols="12" md="6" lg="4" xl="3" v-show="leaveAuth.every(element => userClaims.includes(element))">
                <dashboard-item to="ConfirmLeave" color="green" icon="mdi-note-text-outline" :title="$t('manager_page.overview.leave_request')" 
                :subtitle="$t('manager_page.overview.leave_request_subtitle')"></dashboard-item>
            </v-col>
            
            <v-col cols="12" md="6" lg="4" xl="3" v-show="overtimeAuth.every(element => userClaims.includes(element))">
                <dashboard-item to="ConfirmOvertime" color="indigo" icon="mdi-note-text-outline" :title="$t('manager_page.overview.overtime_request')" 
                :subtitle="$t('manager_page.overview.overtime_request_subtitle')"></dashboard-item>
            </v-col>

            <v-col cols="12" md="6" lg="4" xl="3" v-show="businessAuth.every(element => userClaims.includes(element))">
                <dashboard-item to="ConfirmBusiness" color="red" icon="mdi-note-text-outline" :title="$t('manager_page.overview.business_request')" 
                :subtitle="$t('manager_page.overview.business_request_subtitle')"></dashboard-item>
            </v-col>

            <!-- graph -->
            <v-col cols="12" md="6">
                <v-card class="rounded-xl" flat>
                    <v-card-title class="text-subtitle-1">
                        {{ $t("manager_page.overview.current_employee_subtitle") }}
                    </v-card-title>
                    
                    <chart ref="online" :label="$t('manager_page.overview.current_employee_subtitle_chart')" class="mx-auto"
                    :chartData="chartOnlineEmployee" 
                    :ratio="this.$vuetify.breakpoint.name=='xs'? 1 : 3"
                    chartType="line"
                    :scales="currentEmpScale"
                    >
                    </chart>
                </v-card>
            </v-col>
            <!-- TOTAL EMP REPORT -->
            <v-col cols="12" md="6">
                <v-card class="rounded-xl" flat>
                    <v-toolbar flat>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    
                    <chart ref="chartTotalEmp" :label="$t('manager_page.overview.employee_by_month_chart')" class="mx-auto"
                    :chartData="chartDataTotalEmp" :ratio="this.$vuetify.breakpoint.name=='xs'? 1 : 3"
                    chartType="bar" >
                    </chart>
                </v-card>
            </v-col>
            <v-col cols="12" md="3">
                <v-card class="rounded-xl" flat>
                    <v-card-title class="text-subtitle-1 pb-0" style="word-break: normal">
                    {{ $t('manager_page.overview.employee_education_chart') }}
                        <v-spacer></v-spacer>
                        <v-autocomplete color="orange" dense solo flat :items="departments" item-text="name" item-value="code" 
                        :label="$t('manager_page.overview.choose_store')" hide-no-data
                         v-model="paramsEdu.departmentCode" hide-details clearable class="ml-n3">
                        </v-autocomplete>
                    </v-card-title>
                    <v-card-text>
                        <chart ref="chart"
                        :chartData="chartDataEdu" 
                        :chartType="chartType" >
                        </chart>
                        <v-data-table :items="eduOverviews" :headers="educationHeaders" dense>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col cols="12" md="3">
                <v-card class="rounded-xl" flat>
                    <v-card-title class="text-subtitle-1 pb-0" style="word-break: normal">
                    {{ $t('manager_page.overview.employee_position_chart') }}
                        <v-spacer></v-spacer>
                        <v-autocomplete color="orange" dense solo flat :items="departments" item-text="name" item-value="code" :label="$t('manager_page.overview.choose_store')" hide-no-data
                         v-model="paramsPos.departmentCode" hide-details clearable class="ml-n3">
                        </v-autocomplete>
                    </v-card-title>
                    <v-card-text>
                        
                        <chart ref="chartPos" 
                        :chartData="chartDataPos" 
                        :chartType="chartType" >
                        </chart>
                        <v-data-table :items="posOverview" :headers="posHeaders" dense >
                        
                            <template v-slot:[`item.name`]="{item}" > 
                                {{ $t('manager_page.overview.positionGroup.' + item.name) }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Age overview -->
            <v-col cols="12" md="3">
                <v-card class="rounded-xl" flat>
                    <v-card-title class="text-subtitle-1 pb-0" style="word-break: normal">
                    {{ $t('manager_page.overview.employee_age_chart') }}
                        <v-spacer></v-spacer>
                        <v-autocomplete color="orange" dense solo flat :items="departments" item-text="name" item-value="code" :label="$t('manager_page.overview.choose_store')" hide-no-data
                         v-model="paramsAge.departmentCode" hide-details clearable class="ml-n3">
                        </v-autocomplete>
                    </v-card-title>
                    <v-card-text>
                        <chart ref="chartAge"
                        :chartData="chartDataAge" 
                        :chartType="chartType" >
                        </chart>
                        <v-data-table :items="ageOverview" :headers="ageHeaders" dense height="300px">
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <v-dialog ref="dialog" v-model="timeDialog"
        :return-value.sync="customDate" persistent width="290px" >
        <v-date-picker v-model="customDate" scrollable range>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="timeDialog = false" >
                Cancel
            </v-btn>
            <v-btn text color="primary" @click="$refs.dialog.save(customDate)" >
                OK
            </v-btn>
        </v-date-picker>
        </v-dialog>

    </div>
</template>
<script>
import myBreadCrumb from '@/components/BreadCrumb';
import Chart from '@/components/Charts/Chart.vue';
import ApiServices from '../../../components/services/ApiServices';
import http from '../../../components/services/http-common';
import moment from 'moment';
import DashboardItem from '@/components/Dashboard/DashboardItem.vue';
export default {
    components: {
        myBreadCrumb,
        "chart": Chart,
        DashboardItem
    },
    watch:{
        'paramsEdu.departmentCode': {
            handler(val) {
                this.fetchEdu();
            }
        },
        
        'paramsPos.departmentCode': {
            handler(val) {
                this.fetchPos();
            }
        },
        'paramsAge.departmentCode': {
            handler(val) {
                this.fetchAge();
            }
        },
        'paramsTotalEmp.type': {
            handler(val) {
                this.fetchAge();
            }
        }
    },
    props: ["breadcrumbs", "icon"],
    computed: {
        userClaims () {
            return localStorage.getItem("userClaim").split(',');
        },
        test() {
            return this.leaveAuth.every(element => this.userClaims.includes(element));
        }
    },
    data(){
        return {
            timeMenu: false,
            timeDialog: false,
            customDate:[],
            online:0,
            leaveAuth: ["module:employment", "request:index"],
            overtimeAuth: ["module:employment", "request:index"],
            businessAuth: ["module:employment", "request:index"],
            
            //position
            departments:[],
            paramsEdu:{
                departmentCode:null,
            },
            paramsPos:{
                departmentCode:null,
            },
            paramsAge:{
                departmentCode:null,
            },
            
            paramsTotalEmp:{
                type:"MONTH",
            },

            eduOverviews:[],
            educationHeaders:[
                { text: this.$t('manager_page.overview.education_level'), value: 'name'},
                { text: this.$t('manager_page.overview.employee_count'), value: 'value'},
            ],
            
            posOverview:[],
            posHeaders:[
                { text: this.$t('manager_page.overview.position'), value: 'name'},
                { text: this.$t('manager_page.overview.employee_count'), value: 'value'},
            ],
            
            ageOverview:[],
            ageHeaders:[
                { text: this.$t('manager_page.overview.age_group'), value: 'name'},
                { text: this.$t('manager_page.overview.employee_count'), value: 'value'},
            ],

            totalEmpOverviews:[],
            totalEmpHeaders:[
                { text: 'Tháng', value: 'name'},
                { text: this.$t('manager_page.overview.employee_count'), value: 'value'},
            ],
            currentEmpScale: 
                    {
                        y: {
                            min: 0,     // start at 0
                            max: 200,   // or calculate dynamically
                            ticks: {
                                stepSize: 50
                            }
                        }
                    },
            
            chartType: "pie",
            chartDataEdu: {
                labels: [],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        backgroundColor: []
                    },
                ],
            },

            chartDataPos: {
                labels: [],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        backgroundColor: []
                    },
                ],
            },
            
            chartDataAge: {
                labels: [],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        backgroundColor: []
                    },
                ],
            },
            
            chartDataTotalEmp: {
                labels: [
                this.$t("common.month.t1"), 
                this.$t("common.month.t2"),
                this.$t("common.month.t3"),
                this.$t("common.month.t4"),
                this.$t("common.month.t5"),
                this.$t("common.month.t6"),
                this.$t("common.month.t7"),
                this.$t("common.month.t8"),
                this.$t("common.month.t9"),
                this.$t("common.month.t10"),
                this.$t("common.month.t11"),
                this.$t("common.month.t12")
                ],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        backgroundColor: [],
                        borderColor: [],
                        borderWidth: 2,
    
                    },
                ],
            },
            chartOnlineEmployee: {
                labels: [
                    moment().add(1, 'minute').format('hh:mm:ss'),
                    moment().add(2, 'minute').format('hh:mm:ss'),
                    moment().add(3, 'minute').format('hh:mm:ss'),
                    moment().add(4, 'minute').format('hh:mm:ss'),
                    moment().add(5, 'minute').format('hh:mm:ss'),
                    ],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],                    
                        cubicInterpolationMode: 'monotone',
                        tension: 0.4,
                        backgroundColor: [],
                        borderColor: [],
                        borderWidth: 2
                    },
                ],
            }
        }
    },
    methods:{
        hslToHex(h, s, l) {
            s /= 100; l /= 100;
            const k = n => (n + h / 30) % 12;
            const a = s * Math.min(l, 1 - l);
            const f = n => {
                const val = l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
                return Math.round(255 * val);
            };
            const r = f(0), g = f(8), b = f(4);
            const toHex = v => v.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
        },
        paletteGolden(n, opts = {}) {
            const {
                seedHue = Math.floor(Math.random() * 360),
                saturation = 62,
                lightness = 54,
                golden = 137.50776405003785 // golden angle in degrees
            } = opts;

            const colors = [];
            let h = seedHue;
            for (let i = 0; i < n; i++) {
                colors.push(this.hslToHex(h % 360, saturation, lightness));
                h += golden;
            }
            return colors;
        },
        setMonth(){
            this.params.from= moment().startOf("month").format("YYYY-MM-DD");
            this.params.to= moment().endOf("month").format("YYYY-MM-DD");
        },
        setQuarter(){
            this.params.from= moment().startOf("quarter").format("YYYY-MM-DD");
            this.params.to= moment().endOf("quarter").format("YYYY-MM-DD");
        },
        
        fetchDepartment() {
            return ApiServices.fetchDepartment().then(res => {
                this.departments = res.data;
            })
        },

        fetchEdu(){
            this.paramsEdu.lang = this.$i18n.locale
            return http.get("employees/overview/education", {
                params: this.paramsEdu
            }).then(res => {
                let jobOverviewResults = res.data;
                this.eduOverviews = res.data;
                this.chartDataEdu.labels=[];
                this.chartDataEdu.datasets[0].data=[];
                this.chartDataEdu.datasets[0].backgroundColor=this.paletteGolden(jobOverviewResults.length);
                
                jobOverviewResults.forEach(x => {
                    this.chartDataEdu.labels.push(x.name);
                    this.chartDataEdu.datasets[0].data.push(x.value);
                    // this.chartDataEdu.datasets[0].backgroundColor.push(this.getRandomColor());
                });
                this.$refs.chart.update();
            })
        },
        
        fetchPos(){
            return http.get("employees/overview/position", {
                params: this.paramsPos
            }).then(res => {
                let result = res.data;
                this.posOverview = res.data;
                this.chartDataPos.labels=[];
                this.chartDataPos.datasets[0].data=[];
                this.chartDataPos.datasets[0].backgroundColor=this.paletteGolden(result.length);
                result.forEach(x => {

                    var translatedName = this.$t("manager_page.overview.positionGroup." + x.name)
                    this.chartDataPos.labels.push(translatedName);
                    this.chartDataPos.datasets[0].data.push(x.value);
                    // this.chartDataPos.datasets[0].backgroundColor.push(this.getRandomColor());
                });
                this.$refs.chartPos.update()
            })
        },
        fetchAge(){
            return http.get("employees/overview/age", {
                params: this.paramsAge
            }).then(res => {
                let result = res.data;
                this.ageOverview = res.data;
                this.chartDataAge.labels=[];
                this.chartDataAge.datasets[0].data=[];
                this.chartDataAge.datasets[0].backgroundColor=this.paletteGolden(result.length);
                result.forEach(x => {
                    this.chartDataAge.labels.push(x.name);
                    this.chartDataAge.datasets[0].data.push(x.value);
                    // this.chartDataAge.datasets[0].backgroundColor.push(this.getRandomColor());
                });
                this.$refs.chartAge.update()
            })
        },
        fetchTotalEmp(){
            return http.get("employees/overview/total-employee", {
                params: this.paramsAge
            }).then(res => {
                let result = res.data;
                this.totalEmpOverviews = res.data;
                // this.chartDataTotalEmp.labels=[];
                this.chartDataTotalEmp.datasets[0].data=[];
                this.chartDataTotalEmp.datasets[0].backgroundColor=[];
                this.chartDataTotalEmp.datasets[0].borderColor=[];
                result.forEach(x => {
                    // this.chartDataTotalEmp.labels.push(x.name);
                    this.chartDataTotalEmp.datasets[0].data.push(x.value);
                    this.chartDataTotalEmp.datasets[0].backgroundColor.push('rgba(165, 214, 167)');
                    this.chartDataTotalEmp.datasets[0].borderColor.push('rgb(46, 125, 50)');
                });
                this.$refs.chartTotalEmp.update()
            })
        },
        getRandomColor() {
            var letters = '0123456789ABCDEF'.split('');
            var color = '#';
            for (var i = 0; i < 6; i++ ) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        
        fetchEventsList () {
            return http.get("employeeDashboard/current-emp").then(res => {
                let online = res.data;
                let dataLength = this.chartOnlineEmployee.datasets[0].data.length;
                if(dataLength>5)
                {
                    this.chartOnlineEmployee.labels.splice(0, 1);
                    this.chartOnlineEmployee.datasets[0].data.splice(0, 1);
                    this.chartOnlineEmployee.datasets[0].backgroundColor.splice(0, 1);
                    this.chartOnlineEmployee.datasets[0].borderColor.splice(0, 1);
                    this.chartOnlineEmployee.labels.push(moment().format("hh:mm:ss"));
                }

                this.chartOnlineEmployee.datasets[0].data.push(online);
                this.chartOnlineEmployee.datasets[0].backgroundColor.push('rgba(165, 214, 167)');
                this.chartOnlineEmployee.datasets[0].borderColor.push('rgb(46, 125, 50)');
                this.$refs.online.update()
            })
        },
        cancelAutoUpdate () {
            clearInterval(this.timer);
        }
    },
    created(){
        const HR_DIRECT = false;
        var isHr = localStorage.getItem('userClaim')?.includes('hr:dashboard')
        if(isHr && HR_DIRECT){
            this.$router.push({name: 'HrEmployeeOverview'})
        }

        this.fetchDepartment();
        this.fetchEdu();
        this.fetchPos();
        this.fetchAge();
        this.fetchTotalEmp();
        
        this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 60000);
    },
    beforeDestroy () {
      this.cancelAutoUpdate();
    }
    
}
</script>